import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {Store} from "@ngrx/store";
import {AppState} from "../../../../core/store/core.state";
import {Subscription} from "rxjs";
import {TipoRendimientos} from "../../../../chacra-core/models/chacra";
import {ChacraTipoRendimiento} from "../../../../chacra-core/enums";
import {AUTH_ROLE_ID} from "../../../../core/models";
import {LocalStorageService} from "../../../../core/services";
import {Rol} from "../../../../core/enums";

@Component({
  selector: 'app-tipo-rendimiento-select',
  templateUrl: './tipo-rendimiento-select.component.html',
  styleUrls: ['./tipo-rendimiento-select.component.scss']
})
export class TipoRendimientoSelectComponent implements OnInit {

  @Output() changeFired = new EventEmitter<string>();

  tipo: ChacraTipoRendimiento = ChacraTipoRendimiento.AGLUTINADOR;
  tipos = TipoRendimientos;
  tiposEnable: ChacraTipoRendimiento[] = [];

  rolId = null;

  subscriptions: Subscription[] = [];

  constructor(private store: Store<AppState>,
              private localStorageService: LocalStorageService,) {
  }

  ngOnInit(): void {
    this.rolId = this.localStorageService.getItem(AUTH_ROLE_ID);
    switch (this.rolId) {
      case Rol.ASEGURADORA: case Rol.DGRN: case Rol.USUARIO_LIBRE: case Rol.PRODUCTOR:
        this.tiposEnable = [
          ChacraTipoRendimiento.AGLUTINADOR,
          ChacraTipoRendimiento.ASEGURADORA,
        ];
        break;

      case Rol.AGLUTINADORA:
        this.tiposEnable = [
          ChacraTipoRendimiento.AGLUTINADOR
        ];
        break;
    }

    if(this.tiposEnable.length > 0){
      this.tipo = this.tiposEnable[0];
      this.changeFired.emit(this.tipo);
    }
  }

  tipoChange(tipo: any) {
    if (this.tipo !== tipo) {
      this.tipo = tipo;
      this.changeFired.emit(this.tipo);
    }
  }

  rubroName(tipo: any) {
    return tipo.name;
  }
}
